import React from 'react';
import { ArrowRight, Heart, TrendingUp, Users, Award } from 'lucide-react';

const jobs = [
  { title: 'Pharmacist (B.Pharm / M.Pharm)', location: 'Chennai, Coimbatore, Madurai', type: 'Full-time', dept: 'Retail Operations' },
  { title: 'Store Manager', location: 'Multiple Locations, Tamil Nadu', type: 'Full-time', dept: 'Retail Operations' },
  { title: 'Franchise Development Manager', location: 'Chennai', type: 'Full-time', dept: 'Business Development' },
  { title: 'Supply Chain Executive', location: 'Chennai', type: 'Full-time', dept: 'Supply Chain' },
  { title: 'Digital Marketing Manager', location: 'Chennai (Remote Friendly)', type: 'Full-time', dept: 'Marketing' },
  { title: 'Finance & Accounts Executive', location: 'Chennai', type: 'Full-time', dept: 'Finance' },
];

const Careers = () => {
  return (
    <div className="">
      <section className="bg-gradient-to-br from-primary-900 via-primary-800 to-secondary-900 text-white py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-4 py-2 text-sm font-medium mb-6">Join Our Team</div>
            <h1 className="font-heading text-5xl font-bold leading-tight mb-6">Build Your Career at <span className="text-secondary-400">APlus Healthcare</span></h1>
            <p className="text-white/80 text-lg leading-relaxed mb-8">We are building India's most trusted pharmacy retail chain and we need talented, passionate people to help us do it. Join a company where your work makes a real difference in people's health and lives.</p>
            <a href="#openings" className="btn-secondary">View Open Positions <ArrowRight className="w-4 h-4" /></a>
          </div>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="section-title">Why Work at <span className="gradient-text">APlus?</span></h2>
            <p className="section-subtitle mx-auto">We offer more than just a job. We offer a chance to build something meaningful.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { icon: Heart, title: 'Meaningful Work', desc: 'Every role at APlus contributes to making healthcare accessible for millions of Indians.', color: 'text-rose-500', bg: 'bg-rose-50' },
              { icon: TrendingUp, title: 'Growth Opportunities', desc: 'As we expand rapidly, there are enormous opportunities for career growth and advancement.', color: 'text-primary-600', bg: 'bg-primary-50' },
              { icon: Users, title: 'Great Culture', desc: 'A collaborative, inclusive workplace where every team member is valued and respected.', color: 'text-secondary-600', bg: 'bg-secondary-50' },
              { icon: Award, title: 'Competitive Compensation', desc: 'Market-competitive salaries, performance bonuses, health insurance, and more.', color: 'text-amber-500', bg: 'bg-amber-50' },
            ].map((item, i) => (
              <div key={i} className="card text-center">
                <div className={`w-14 h-14 ${item.bg} rounded-2xl flex items-center justify-center mx-auto mb-5`}>
                  <item.icon className={`w-7 h-7 ${item.color}`} />
                </div>
                <h3 className="font-heading font-bold text-gray-900 text-lg mb-3">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="openings" className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="section-title">Current <span className="gradient-text">Openings</span></h2>
            <p className="section-subtitle mx-auto">We are actively hiring across multiple functions. Find your next role with us.</p>
          </div>
          <div className="space-y-4">
            {jobs.map((job, i) => (
              <div key={i} className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 hover:shadow-md transition-all duration-300 hover:border-primary-200">
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                  <div>
                    <div className="flex items-center gap-3 mb-2">
                      <h3 className="font-heading font-bold text-gray-900 text-lg">{job.title}</h3>
                      <span className="bg-primary-100 text-primary-700 text-xs font-semibold px-2 py-1 rounded-full">{job.type}</span>
                    </div>
                    <div className="flex flex-wrap gap-4 text-sm text-gray-500">
                      <span>📍 {job.location}</span>
                      <span>🏢 {job.dept}</span>
                    </div>
                  </div>
                  <a href="mailto:careers@aplushealthcare.in" className="btn-primary whitespace-nowrap flex-shrink-0">
                    Apply Now <ArrowRight className="w-4 h-4" />
                  </a>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-12 text-center bg-white rounded-3xl p-10 shadow-sm border border-gray-100">
            <h3 className="font-heading text-2xl font-bold text-gray-900 mb-3">Don't see a suitable role?</h3>
            <p className="text-gray-600 mb-6">We are always looking for talented people. Send us your resume and we'll keep you in mind for future openings.</p>
            <a href="mailto:careers@aplushealthcare.in" className="btn-primary">
              Send Your Resume <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-r from-primary-600 to-secondary-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading text-4xl font-bold text-white mb-4">Ready to Make a Difference?</h2>
          <p className="text-white/80 text-lg max-w-2xl mx-auto mb-8">Join APlus Healthcare and be part of transforming India's healthcare landscape.</p>
          <a href="mailto:careers@aplushealthcare.in" className="bg-white text-primary-700 hover:bg-gray-100 font-semibold py-3 px-8 rounded-lg transition-all duration-300 shadow-lg inline-flex items-center gap-2">
            Email Your Resume <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </section>
    </div>
  );
};

export default Careers;
